module.exports = __webpack_public_path__ + "img/target.e21f745f.svg";